<ng-select
  class="filtro-select"
  [items]="options"
  bindLabel="label"
  [multiple]="multiple"
  [searchable]="searchable"
  [clearable]="false"
  [readonly]="disabled"
  [placeholder]="model ? '' : placeholder"
  [(ngModel)]="model"
  (change)="onChange($event)"
  [appendTo]="'body'"
  [attr.aria-label]="placeholder">
</ng-select>
